// extracted by css-extract-rspack-plugin
export default {"cls1":"NewUserDiscountButton-cls1_rf2","cls2":"NewUserDiscountButton-cls2_vxz NewUserDiscountButton-cls1_rf2","blue":"NewUserDiscountButton-blue_mts"};